const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgePracticaIdCopy = async (id_practica: string, aules: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${id_practica}/copy`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ aules })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
